/**
 * The message "Have Merlin fill it in" sends after a chat is saved as a case
 * (UX loop turns 1 and 2: the new case had no keys or steps although Merlin
 * had already looked up the customer, product and order). Merlin's case-file
 * tools do the filling; the message names the case so they target it, and
 * says not to contact anyone, so the click cannot send mail.
 */
export function fillCaseRequest(caseNo: string): string {
  return (
    `Please fill in case ${caseNo} from what we have found in this conversation: ` +
    'tag it with the customer, product, lot and order you confirmed, add the steps ' +
    'still open with whose desk each one is on, and say where it stands. ' +
    'Do not contact anyone.'
  );
}
